import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_5f3cec3a-3dec-425c-ac43-979e18afef98/artifacts/g1p4ah9b_GMB%20Logo.PNG";

export const COMPANY = {
  name: "Gold Mind Business",
  phone: "+917982156791",
  phoneDisplay: "+91 79821 56791",
  whatsapp: "917982156791",
  email: "info@goldmindbusiness.com",
  address:
    "Rukmani Tower, U-66, Laxmi Nagar, Block S1, Upadhyay Block, Shakarpur, Delhi, 110092",
};
